/** @jsxImportSource @emotion/react */
import React from 'react'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import Grid from '@mui/material/Grid'

const GRID_ZONES = [
  {id: '15', label: 'All'},
  {id: '1', label: 'Northland'},
  {id: '2', label: 'Auckland'},
  {id: '3', label: 'Hamilton'},
  {id: '4', label: 'Edgecumbe'},
  {id: '5', label: 'Hawkes_bay'},
  {id: '6', label: 'Taranaki'},
  {id: '7', label: 'Bunnythorpe'},
  {id: '8', label: 'Wellington'},
  {id: '9', label: 'Nelson'},
  {id: '10', label: 'Christchurch'},
  {id: '11', label: 'Canterbury'},
  {id: '12', label: 'West_coast'},
  {id: '13', label: 'Otago'},
  {id: '14', label: 'Southland'},
]

const INTERVALS = [
  {id: '30minute', label: 'Half hourly'},
  {id: 'daily', label: 'Daily'},
  {id: 'monthly', label: 'Monthly'},
]

const StackedGenerationFilter = ({source, filter, onChange}) => {
  const {gridZone, interval} = filter

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={source === 'generation' ? 6 : 12}>
        <FormControl variant="standard" fullWidth>
          <InputLabel id="grid-zone">Grid Zone</InputLabel>
          <Select
            labelId="grid-zone"
            value={gridZone || ''}
            label="Grid Zone"
            onChange={({target: {value: gridZone}}) => onChange({...filter, gridZone})}
          >
            {GRID_ZONES.map(({id, label}) => <MenuItem key={id} value={id}>{label}</MenuItem>)}
          </Select>
        </FormControl>
      </Grid>
      {source === 'generation' &&
      <Grid item xs={12} sm={6}>
        <FormControl variant="standard" fullWidth>
          <InputLabel id="interval">Interval</InputLabel>
          <Select
            labelId="interval"
            value={interval || ''}
            label="Interval"
            onChange={({target: {value: interval}}) => onChange({...filter, interval})}
          >
            {INTERVALS.map(({id, label}) => <MenuItem key={id} value={id}>{label}</MenuItem>)}
          </Select>
        </FormControl>
      </Grid>}
    </Grid>
  )

}

const styles = {
  container: {
    display: 'flex',
  }
}

export default StackedGenerationFilter